// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Point
 */
export interface Point {
  /**
   *
   */
  type: PointTypeEnum;
  /**
   * Coordinates in longitude, latitude (easting, northing) order.
   */
  coordinates: Array<any>;
}

/**
 * @export
 */
export const PointTypeEnum = {
  Point: "Point",
} as const;
export type PointTypeEnum = (typeof PointTypeEnum)[keyof typeof PointTypeEnum];

/**
 * Check if a given object implements the Point interface.
 */
export function instanceOfPoint(value: object): value is Point {
  if (!("type" in value) || value["type"] === undefined) return false;
  if (value["type"] !== "Point") return false;

  if (!("coordinates" in value) || value["coordinates"] === undefined) return false;
  return true;
}

export function PointFromJSON(json: any): Point {
  return PointFromJSONTyped(json, false);
}

export function PointFromJSONTyped(json: any, ignoreDiscriminator: boolean): Point {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"],
    coordinates: json["coordinates"],
  };
}

export function PointToJSON(json: any): Point {
  return PointToJSONTyped(json, false);
}

export function PointToJSONTyped(value?: Point | null, ignoreDiscriminator: boolean = false): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    coordinates: value["coordinates"],
  };
}
